import { render, staticRenderFns } from "./indexNew.vue?vue&type=template&id=d8150512&"
import script from "./indexNew.vue?vue&type=script&lang=ts&"
export * from "./indexNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports